/**
 * TrendyChallengeCard - New card style with gradient overlay and inline "Join Now" button
 * Used on the welcome screen for first-time users to showcase trendy challenges
 */

import { getChallengeImage } from "@/utils/challengeHelpers";

interface TrendyChallengeCardProps {
  id: string;
  name: string;
  type: string;
  totalDays: number;
  dailyGoal: number;
  onClick?: () => void;
}

export function TrendyChallengeCard({
  name,
  type,
  totalDays,
  dailyGoal,
  onClick,
}: TrendyChallengeCardProps) {
  const imageUrl = getChallengeImage(type);

  // Format daily goal display (e.g., "5 km/Daily")
  const formatDailyGoal = () => {
    return `${dailyGoal} K/Daily`;
  };

  return (
    <div
      className="relative w-[300px] h-[180px] rounded-xl overflow-hidden cursor-pointer shrink-0 transition-transform hover:scale-[1.02] active:scale-[0.98]"
      onClick={onClick}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${imageUrl})` }}
      />

      {/* Gradient Overlay - Left dark to right transparent */}
      <div className="trendy-card-overlay absolute inset-0" />

      {/* Content */}
      <div className="relative h-full flex flex-col justify-between p-5">
        {/* Top Section - Title */}
        <div>
          <h3 className="text-white font-medium text-lg leading-tight max-w-[160px] font-sf-pro">
            {name}
          </h3>
        </div>

        {/* Join Now Button */}
        <button
          className="w-fit px-4 py-1.5 bg-[#21f219] rounded-xl text-black text-[11px] font-medium font-dm-sans hover:brightness-110 transition-all"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
        >
          Join Now
        </button>

        {/* Bottom Section - Metadata */}
        <div className="flex items-center gap-4">
          {/* Duration */}
          <div className="flex items-center gap-1.5">
            <span
              className="material-symbols-outlined text-white"
              style={{ fontSize: "14px" }}
            >
              schedule
            </span>
            <span className="text-white text-[11px] font-medium font-dm-sans">
              {formatDailyGoal()}
            </span>
          </div>

          {/* Total Days */}
          <div className="flex items-center gap-1.5">
            <span
              className="material-symbols-outlined text-white"
              style={{
                fontSize: "14px",
                fontVariationSettings: "'FILL' 1",
              }}
            >
              local_fire_department
            </span>
            <span className="text-white text-[11px] font-medium font-dm-sans">
              {totalDays} Days
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
